export default __webpack_public_path__ + "static/media/logo.0a0b3599.svg";